import React from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router';
import './styles/ReviewMenu.scss';

const ReviewMenu = ({
  page,
  schoolYearId
}) => {
  const menuItems = [
    {
      name: 'Documents for Review',
      canonical: 'documents'
    },
    {
      name: 'Candidate Cover Sheet',
      canonical: 'cover_sheet'
    },
    {
      name: 'Rating Criteria',
      canonical: 'rating_criteria'
    },
    {
      name: 'Review List Columns & Filters',
      canonical: 'columns_and_filters'
    },
    {
      name: 'Preliminary Decision Types',
      canonical: 'decision_types'
    }
  ];

  return (
    <Nav
      defaultActiveKey={`/setup/review/${page}`}
      variant='pills'
      className='review-settings-menu'
    >
      {menuItems.map(item => (
        <Nav.Item key={item.canonical}>
          <Link
            className='nav-link'
            activeClassName='active'
            to={`/setup/review/${item.canonical}${schoolYearId ? `?school_year_id=${schoolYearId}` : ''}`}
          >
            {item.name}
          </Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

ReviewMenu.propTypes = {
  /** Current Page */
  page: PropTypes.string,
  schoolYearId: PropTypes.string
};

ReviewMenu.defaultProps = {
  page: '',
  schoolYearId: ''
};

export default ReviewMenu;
